module.exports = __webpack_public_path__ + "addf1378437e725833aacc8165ef751d.woff";